// removed by extract-text-webpack-plugin
module.exports = {"cardWrapper":"_1KR4ek1yanHVkFRjfko7wa","card":"_3Mxm6QC1-0Pdwn_F_IQbWi","cardImgWrapper":"_10cdmApEDxamDT5RN2BYZn","cardImg":"Yt2qeJW3rwsc93pYRRyH7","content":"rfXkfKf3n9t8Jr2z3zXty","title":"_2zig-pbmwfL3WUu7AGbasA","totalCount":"_2yQlV7nHTOeQ_sXfAS_lvd","cardStack1":"_2rOzatxjI9IXIY7jrp524n","cardStack2":"_3QYxNYjP66QYijCxlq2vOB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Box/CollectionCardMobile.scss
// module id = 1099
// module chunks = 0